import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Dialog, DialogTrigger, DialogContent, DialogClose } from "@tenant/ui";
import clsx from "clsx";
import { CreditHistorySummary } from "../CreditHistorySummary";
import styles from "./styles.module.scss";

interface CreditHistoryDialogProps {
  className?: string;
  children?: React.ReactNode;
}

export const CreditHistoryDialog: React.FC<CreditHistoryDialogProps> = ({
  children,
  className,
}) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "CreditHistoryDialog");

  return (
    <Dialog>
      <DialogTrigger
        asChild
        className={clsx(cn("button-container"), className)}
      >
        {children}
      </DialogTrigger>

      <DialogContent
        className={block}
        title={t("wallet.credits.transaction.creditActivity")}
      >
        <CreditHistorySummary>
          <DialogClose className={cn("button-container")}>
            <button className={cn("button")}>{t("close.button")}</button>
          </DialogClose>
        </CreditHistorySummary>
      </DialogContent>
    </Dialog>
  );
};
